import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl,GetDatasyncMediaOneBlockSynchronously,SyncDeleteSynchronously} from "datasync-core";
import { globals} from "../Components/Globals/Globals";
import { produce } from 'immer';
const initialState = {
  hiringContactsItems: [],
  hiringContactCount: 0,
  loadHiringContacts_result:{status: 'idle', error: null},
  deleteHiringContact_result:{status: 'idle', error: null},
  validateHiringContacts_result:{status: 'idle', error: null, stat_email:null, stat_action:null},
}

// Create an async thunk for loading hiringContacts
export const loadHiringContacts = createAsyncThunk(
  'hiringContacts/loadHiringContacts',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.platform_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        seek_filter_clause: ` true `, // Do not filter hiringContacts
        table_guid: globals.datasync.pf_hiringContacts_table_guid,
        debugging: true
      });
      if (globals.parameters.debugging)
        console.log("loadHiringContacts::hiringContacts response = ",response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for deleting hiringContacts
export const deleteHiringContact = createAsyncThunk(
  'hiringContacts/deleteHiringContact',
  async (deletedHiringContactObject) => {
    try {
      console.clear()
      console.log("deletedHiringContactObject->", deletedHiringContactObject)
      //Delete hiringContact from Remote Datasync Database
      const response = await SyncDeleteSynchronously({
        datasync_url:globals.datasync_service.url,
        data_guid: deletedHiringContactObject.data_guid});
      
      if (globals.parameters.debugging)
        console.log("deleteHiringContact->response = ",response)

      if (response.err || response.deleted_data_count !=1)
        throw(response.err)

      return response;
    } catch (error) {
      return deletedHiringContactObject.rejectWithValue(error.message);
    }
  }
);

const hiringContactSlice = createSlice({
  name: 'hiringContacts',
  initialState,
  reducers: {
    addHiringContact(state, action) {
      // New stat added 
      try {
        if (globals.parameters.debugging){
          console.log("addHiringContact: ", state.hiringContactsItems)
          console.log("addHiringContact: ", state.hiringContactCount)
          console.log("addHiringContact::action ->", action)  
        }
  
        state.hiringContactCount++;
        state.hiringContactsItems.push(action.payload);
      } catch (error) {
        console.error("HiringContact added but state list insertion fails !")
        alert("Echec de l'insertion du nouvel utilisateur en mémoire interne")
      }
    },

    updateHiringContact(state, action) {
      return produce(state, draft => {
        //Find former stat object to update
        const updatedHiringContactObject = draft.hiringContactsItems.find((hiringContact) => hiringContact.data_guid === action.payload.data_guid)
        console.log("updateHiringContact: updatedHiringContactObject->", updatedHiringContactObject)
        if (updatedHiringContactObject) {
          //update hiringContact in the array
          updatedHiringContactObject.data_blob.data_tier = action.payload.data_blob.data_tier;
        } else {
          console.error("updateHiringContact: HiringContact not found in the array");
        }
      })
    },

    revertAllHiringContacts(state){
      console.log("hiringContactSlice revertAllHiringContacts");
      state.hiringContactsItems = [];
      state.hiringContactCount = 0;
      state.loadHiringContacts_result = {status: 'idle', error: null};
      state.deleteHiringContact_result = {status: 'idle', error: null};
      state.validateHiringContacts_result = {status: 'idle', error: null, stat_email:null, stat_action:null};
    },

    revertStatusHiringContacts(state){
      if (globals.parameters.debugging)
        console.log("revertStatusHiringContacts")

      state.deleteHiringContact_result = {status: 'idle', error: null};
      state.validateHiringContacts_result = {status: 'idle', error: null, stat_email:null, stat_action:null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadHiringContacts */
      .addCase(loadHiringContacts.pending, (state, action) => {
        state.loadHiringContacts_result = {status : "loading",error : null};
      })
      .addCase(loadHiringContacts.fulfilled, (state, action) => {
        if (action.payload.length > 0) {
          state.loadHiringContacts_result = {status : "succeeded",error : null};
          state.hiringContactsItems = action.payload;
          state.hiringContactCount= action.payload.length;
        }
        else {
          state.loadHiringContacts_result = {status : "succeeded",error : "No hiringContacts found !!!"};
          state.hiringContactsItems = [];
          state.hiringContactCount= 0;
        }
      })
      .addCase(loadHiringContacts.rejected, (state, action) => {
        state.loadHiringContacts_result = {status : "failed",error : action.payload};
      })

      /* deleteHiringContact */
      .addCase(deleteHiringContact.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteHiringContact.pending")
        console.log("deleteHiringContact.pending -> action", action)
        state.deleteHiringContact_result = {status : "deleting",error : null};
      })
      .addCase(deleteHiringContact.fulfilled, (state,action) => {
        //HiringContact sucessfully deleted from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("deleteHiringContact.fulfilled")
        console.log("deleteHiringContact.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Delete hiringContact from local state
          draft.hiringContactsItems = draft.hiringContactsItems.filter((hiringContact, j) => hiringContact.data_guid !== action.payload.data_guid)
          draft.hiringContactCount--;

          draft.deleteHiringContact_result = {status : "deleted",error : null};
        })
      })
      .addCase(deleteHiringContact.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteHiringContact.rejected")
          console.log("deleteHiringContact.rejected -> action", action)
        state.deleteHiringContact_result = {status : "failed",error : action.payload};
      })
  },
});

export const { addHiringContact, updateHiringContact, revertAllHiringContacts, revertStatusHiringContacts } = hiringContactSlice.actions;
export default hiringContactSlice.reducer;